import { render } from "./MorePerks01.vue?vue&type=template&id=5c6d2e98&scoped=true"
const script = {}

import "./MorePerks01.vue?vue&type=style&index=0&id=5c6d2e98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6d2e98"]])

export default __exports__